export const feedCardVariants = {
    hostCard: 'host',
    marketing: 'marketing',
    lastFilter: 'lastFilter',
    allCaughtUp: 'allCaughtUp',
    seeMoreRookies: 'seeMoreRookies',
    telegramBot: 'telegramBot',
    goalTeaser: 'goalTeaser',
    filter: 'filter',
    moengage: 'moengage',
    chatTopics: 'chatTopics',
    favActivities: 'favActivities',
    cashback: 'cashback',
    topHost: 'topHost'
} as const
